var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Optional } from "../Optional";
import { MaryActionTypeKeys, } from "./ActionTypes";
import { maryStateInit, } from "./MaryProvider";
import { State } from "./State";
/**
 *
 * @param red
 */
export var withMaryReducers = function (red) { return (red
    .register(MaryActionTypeKeys.MARY_INIT, maryInitReducer)
    .register(MaryActionTypeKeys.MARY_UPDATE, maryUpdateReducer)
    .register(MaryActionTypeKeys.MARY_UNLINK, maryUnlinkReducer)); };
/**
 *
 */
// export const maryReducer = withMaryReducers(Reducers
//     .create<MaryActionTypeKeys, MaryState>());
/**
 *
 * @param s
 * @param a
 */
var maryInitReducer = function (s, a) { return (maryUpdateReducer(s.setProp("mary", State.create(maryStateInit)), __assign(__assign({}, a), { type: MaryActionTypeKeys.MARY_UPDATE }))); };
/**
 *
 */
var maryUpdateReducer = function (s, a) { return (s.setProp("mary", Optional.ofOpt(s.prop("mary"))
    .map(function (m) { return (m
    .setProp("breakpoints", m.prop("breakpoints").updateWith(__assign({}, a.breakpoint)))
    .setProp("modal", m.prop("modal").updateWith(__assign({}, a.modalWrapper)))
    .setProp("flex", m.prop("flex").updateWith(__assign({}, a.flexWrapper)))); })
    .getOpt())); };
/**
 *
 * @param s
 * @param a
 */
var maryUnlinkReducer = function (s, _a) { return (s.setProp("mary", undefined)); };
